export default __webpack_public_path__ + "static/media/the-next-day.2bb5dcef.webp";